import { createSlice } from '@reduxjs/toolkit'

export interface IMatchListViewDataState {
    pagination: {
        itemsPerPage: number
        currentPage: number
        total: number
    }
    addCompaniesModalVisible: boolean
    searchValue: string | null
    filters?: any
    sort?: string
    projection?: any
    needPopulate: boolean
    populates?: any
    selectedRowKeys?: string[]
}

const initialState: IMatchListViewDataState = {
    pagination: {
        itemsPerPage: 10,
        currentPage: 1,
        total: 0
    },
    addCompaniesModalVisible: false,
    searchValue: null,
    filters: {},
    sort: '-createdAt',
    projection: [],
    needPopulate: true,
    populates: [],
    selectedRowKeys: []
}

const matchListViewSlice = createSlice({
    name: 'ui/match-list-view',
    initialState,
    reducers: {
        onChangePagination(state, acion) {
            state.pagination = { ...state.pagination, ...acion.payload }
        },
        onChangeSelectedRows(state, action) {
            state.selectedRowKeys = action.payload
        },
        onChangeSearch(state, action) {
            state.searchValue = action.payload
        },
        onChangeAddCompaniesModalVisibility(state, action) {
            state.addCompaniesModalVisible = action.payload
        },
        onChangeTotal(state, action) {
            state.pagination = { ...state.pagination, total: action.payload }
        }
    }
})

export const matchListViewActions = matchListViewSlice.actions
export default matchListViewSlice.reducer
